<template>
  <div class="pt-8 flex">
    <div class="m-auto space-y-8 px-4">
      De tour is niet gevonden.<br/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueNotFound'
}
</script> 